var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wtxh-m"},[_c('p',{staticClass:"footer-text"},[_vm._v(" 技术支持：中工科创   京ICP备"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("16012224号")]),_c('br'),_vm._v(" Copyright © 2017-2026 kjcxchina.com All Rights Reserved ")])])
}]

export { render, staticRenderFns }